import React, { useRef, useEffect } from 'react';
import MessageInput from './MessageInput';
import { ChatHeader } from './ChatHeader';
import { MessageBubble } from './MessageBubble';
import { CustomerDetailsDrawer } from './CustomerDetailsDrawer';
import { useCustomerDetails } from '../hooks/useCustomerDetails';

const ChatWindow = ({ 
  conversation, 
  messages, 
  onSendMessage, 
  onAssign, 
  onBack, 
  currentUser, 
  onOpenAssign 
}) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const {
    isCustomerDrawerOpen,
    openCustomerDrawer,
    closeCustomerDrawer,
    currentLead,
    loadingLead
  } = useCustomerDetails();

  return (
    <div className="flex flex-col h-full relative bg-[#EFEAE2]">
      {/* Header */}
      <ChatHeader 
        conversation={conversation}
        onBack={onBack}
        currentUser={currentUser}
        onOpenAssign={onOpenAssign}
        onClickCustomerInfo={() => openCustomerDrawer(conversation?.customerPhone)}
      />

      {/* Messages Area - With WhatsApp-like background pattern */}
      <div 
        className="flex-1 overflow-y-auto p-4 md:p-6 space-y-3 relative" 
        style={{ 
          backgroundImage: 'url("https://web.whatsapp.com/img/bg-chat-tile-dark_a4be512e7195b6b733d9110b408f075d.png")', 
          opacity: 0.95,
          backgroundSize: '400px'
        }}
      >
        {messages.length === 0 ? (
          <div className="flex flex-col items-center justify-center my-12 gap-4 px-4 relative z-10">
            <div className="text-center text-gray-800 bg-[#FFEED7] shadow-sm px-6 py-3 rounded-lg inline-block w-full max-w-md text-[13px] font-medium leading-relaxed">
              No messages yet. Send a message to start the conversation.
            </div>
            <div className="text-center bg-[#FFEED7] shadow-sm text-gray-800 px-6 py-4 rounded-lg inline-block w-full max-w-md">
              <p className="font-bold mb-2 flex items-center justify-center gap-2 text-[14px]">
                <svg className="w-5 h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                Twilio Sandbox Notice
              </p>
              <p className="text-[13px] leading-relaxed">
                This number must first join the Twilio Sandbox by sending <strong>'join team-sun'</strong> to <strong>+1 (415) 523-8886</strong> before messaging can start.
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-2 relative z-10">
            {messages.map((msg, index) => (
              <MessageBubble key={msg._id || msg.messageSid || index} msg={msg} />
            ))}
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Input Area */}
      <div className="bg-[#F0F2F5] px-4 py-3 z-10">
        <MessageInput onSend={onSendMessage} disabled={conversation.status === 'resolved'} />
      </div>

      <CustomerDetailsDrawer 
        isOpen={isCustomerDrawerOpen}
        onClose={closeCustomerDrawer}
        conversation={conversation}
        messages={messages}
        leadData={currentLead}
        loadingLead={loadingLead}
        onOpenAssign={onOpenAssign}
        currentUser={currentUser}
      />
    </div>
  );
};

export default ChatWindow;
